export default __webpack_public_path__ + "static/media/logo-Growyx-whiteText.78b7f54e.svg";